module.exports = __webpack_public_path__ + "img/questions-bg.a2a6a4d6.png";